import { AsyncThunk, createAsyncThunk } from "@reduxjs/toolkit";
import { AppDispatchType } from "../types/dispatch.types";
import { RootState } from "../types/store.types";

export function createTypedAsyncThunk<ReturnType, ArgType = void>(
  typePrefix: string,
  payloadCreator: (
    arg: ArgType,
    thunkAPI: { dispatch: AppDispatchType; getState: () => RootState }
  ) => Promise<ReturnType> | ReturnType
): AsyncThunk<ReturnType, ArgType, { state: RootState; dispatch: AppDispatchType }> {
  return createAsyncThunk<ReturnType, ArgType, { state: RootState; dispatch: AppDispatchType }>(
    typePrefix,
    (arg, thunkAPI) => payloadCreator(arg, { ...thunkAPI })
  );
}
